import Tana from "./assets/images/image1.jpg";
import Stevan from "./assets/images/image2.jpg";
import Misa from "./assets/images/image3.jpg";
import Dusan from "./assets/images/image4.jpg";
import Malusev from "./assets/images/image5.jpg";
import Aleksandar from "./assets/images/image6.jpg";
import Stefan from "./assets/images/image7.jpg";
import Bogdanovic from "./assets/images/image8.jpg";
import Andrej from "./assets/images/image9.jpg";
import Djana from "./assets/images/image10.jpg";

export const team = [
  {
    name: "Mile Puničić",
    picture: Tana,
    position: "CEO",
    info: `The team’s larger-than-life CEO, the kind of guy whose energy and ambition are so overbuilt they might as well come with a warning label. He keeps every meeting hard and long, stretching every project to its maximum potential, and somehow everything always rises on schedule. Investors joke that Mile’s “pipeline” is always full, and engineers whisper that his releases are so big and well-timed they could embarrass anyone else in the industry. His office is a controlled chaos of sprint boards and caffeine, and Mile navigates it all with the confidence of someone who knows he’s the biggest tool in the shed—and proudly so.`,
    social: {
      ig: "#",
      fb: "#",
      in: "https://www.linkedin.com/in/milepunicic/",
      em: "mailto:punicic@uon.rs"
    }
  },
  {
    name: "Živko Nabitić",
    picture: Djana,
    position: "BACKEND DEVELOPER",
    info: `The team’s legendary backend engineer, a man obsessed with digging deep into system cores until every byte aligns in perfect order. He believes no database is too dense to penetrate and no query too complex to handle. His colleagues claim he optimizes APIs like a sculptor carves marble—methodical, relentless, and completely absorbed in the depth of his code.`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/zivkonabitic/",
      em: "mailto:nabitic@uon.rs"
    }
  },
  {
    name: "Rade Krutić",
    picture: Stevan,
    position: "DEVOPS ENGINEER",
    info: `Runs DevOps with the discipline of a military drill sergeant. His servers never wobble, his containers never leak, and his CI/CD pipelines are as rigid as his code standards. Rade is allergic to shortcuts; every process he builds must be unbreakable, even if it takes twice as long.`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/rade-krutic",
      em: "mailto:krutic@uon.rs"
    }
  },
  {
    name: "Pero Dignić",
    picture: Misa,
    position: "FRONTEND DEVELOPER",
    info: `Handles the frontend with the pride of an artist and the precision of an engineer. His interfaces rise smoothly, pixel by pixel, until users can’t help but admire their polish. If something doesn’t render perfectly across devices, Pero will rebuild the entire framework just to watch it rise correctly.`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/pero-dignic",
      em: "mailto:dignic@uon.rs"
    }
  },
  {
    name: "Sreto Stojičić",
    picture: Dusan,
    position: "QA SPECIALIST",
    info: `QA incarnate—immovable, sharp-eyed, and merciless toward bugs. He stands firm through long nights of testing, armed with logs, scripts, and an uncanny ability to find flaws invisible to everyone else. “If it breaks under me,” he says, “it’s not ready for the world."`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/sreto-stojicic",
      em: "mailto:stojicic@uon.rs"
    }
  },
  {
    name: "Boro Tvrdičić",
    picture: Malusev,
    position: "INFOSEC SPECIALIST",
    info: `Fortifies the team’s security like a digital fortress builder. Every system he touches becomes a vault; every password policy is enforced with near-religious fervor. He encrypts with such precision that sometimes even the team jokes that Boro’s code is safer than the national treasury`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/boro-tvdicic",
      em: "mailto:tvrdicic@uon.rs"
    }
  },
  {
    name: "Dragan Nabojčić",
    picture: Aleksandar,
    position: "HARDWARE DESIGNER",
    info: `The hardware visionary—always charged, always sparking with new ideas. He designs circuits that hum with potential, balancing brute force with elegance. His favorite saying is, “Energy is useless unless it’s properly directed,” a motto reflected in every device he helps bring to life.`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/dragan-nabojcic/",
      em: "mailto:nabojcic@uon.rs"
    }
  },
  {
    name: "Zoran Prčić",
    picture: Stefan,
    position: "SCRUM MASTER",
    info: `Serves as Scrum Master, lifting team morale and keeping every stand-up session light but focused. He’s known for raising spirits during crunch time, ensuring no one burns out before the final push. His leadership style blends humor, discipline, and an uncanny ability to “elevate” team performance when deadlines loom.`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/zoran-prcic/",
      em: "mailto:prcic@uon.rs"
    }
  },
  {
    name: "Milan Nateglić",
    picture: Andrej,
    position: "NETWORK ENGINEER",
    info: `Architects networks that stretch across continents yet never lose integrity. He thrives under pressure, balancing massive bandwidth demands with delicate system constraints. His designs are so well-tuned that even when pushed to the limit, they hold strong without breaking a single connection.`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/milan-nateglic/",
      em: "mailto:nateglic@uon.rs"
    }
  },
  {
    name: "Slobodan Karatić",
    picture: Bogdanovic,
    position: "SYSTEMS ENGINEER",
    info: `The systems engineer who brings it all together. Known for his meticulous integrations and near-obsessive attention to detail, he tightens every connection until the infrastructure hums in perfect harmony. The team jokes that nothing ever comes loose under Slobodan’s watch—and they’re usually right.`,
    social: {
      fb: "#",
      ig: "#",
      in: "https://www.linkedin.com/in/slobodan-karatic/",
      em: "mailto:karatic@uon.rs"
    }
  }
];
